"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPrice = void 0;
/**
 * Formatiert einen `number` Wert in eine Preisdarstellung, z.B. `'1.00'`
 *
 * @category Utils
 * @param value
 * @returns Formatierten Preis als string
 */
const formatPrice = (value) => {
    if (value === undefined) {
        return '0.00';
    }
    return Number(value).toFixed(2);
};
exports.formatPrice = formatPrice;
